/** Input components */
import { InputBirthdayComponent } from './inputs/input-birthday/input-birthday.component';
import { InputBooleanComponent } from './inputs/input-boolean/input-boolean.component';
import { InputCheckboxesComponent } from './inputs/input-checkboxes/input-checkboxes.component';
import { InputDateComponent } from './inputs/input-date/input-date.component';
import { InputDateTimeComponent } from './inputs/input-datetime/input-datetime.component';
import { InputDurationComponent } from './inputs/input-duration/input-duration.component';
import { InputSecondsComponent } from './inputs/input-seconds/input-seconds.component';
import { InputEmailComponent } from './inputs/input-email/input-email.component';
import { InputEmotionsComponent } from './inputs/input-emotions/input-emotions.component';
import { InputEntityComponent } from './inputs/input-entity/input-entity.component';
import { InputFacebookComponent } from './inputs/input-facebook/input-facebook.component';
import { InputFileComponent } from './inputs/input-file/input-file.component';
import { InputGoogleComponent } from './inputs/input-google/input-google.component';
import { InputImageComponent } from './inputs/input-image/input-image.component';
import { InputLabelComponent } from './inputs/input-label/input-label.component';
import { InputLinkedinComponent } from './inputs/input-linkedin/input-linkedin.component';
import { InputNumberComponent } from './inputs/input-number/input-number.component';
import { InputCurrencyComponent } from './inputs/input-currency/input-currency.component';
import { InputPasswordComponent } from './inputs/input-password/input-password.component';
import { InputPhoneComponent } from './inputs/input-phone/input-phone.component';
import { InputRadioComponent } from './inputs/input-radio/input-radio.component';
import { InputSelectComponent } from './inputs/input-select/input-select.component';
import { InputReadByComponent } from './inputs/input-readby/input-readby.component';
import { InputSkypeComponent } from './inputs/input-skype/input-skype.component';
import { InputStringComponent } from './inputs/input-string/input-string.component';
import { InputTextComponent } from './inputs/input-text/input-text.component';
import { InputTimeComponent } from './inputs/input-time/input-time.component';
import { InputTwitterComponent } from './inputs/input-twitter/input-twitter.component';
import { InputUrlComponent } from './inputs/input-url/input-url.component';
import { InputXingComponent } from './inputs/input-xing/input-xing.component';
import { InputListComponent } from './inputs/input-list/input-list.component';
import { InputSignatureComponent } from './inputs/input-signature/input-signature.component';
/** Fieldset components */
import { FieldsetBirthdayComponent } from './fieldsets/fieldset-birthday/fieldset-birthday.component';
import { FieldsetBooleanComponent } from './fieldsets/fieldset-boolean/fieldset-boolean.component';
import { FieldsetCheckboxesComponent } from './fieldsets/fieldset-checkboxes/fieldset-checkboxes.component';
import { FieldsetDateComponent } from './fieldsets/fieldset-date/fieldset-date.component';
import { FieldsetDatetimeComponent } from './fieldsets/fieldset-datetime/fieldset-datetime.component';
import { FieldsetDurationComponent } from './fieldsets/fieldset-duration/fieldset-duration.component';
import { FieldsetEmailComponent } from './fieldsets/fieldset-email/fieldset-email.component';
import { FieldsetEmotionsComponent } from './fieldsets/fieldset-emotions/fieldset-emotions.component';
import { FieldsetEntityComponent } from './fieldsets/fieldset-entity/fieldset-entity.component';
import { FieldsetReadByComponent } from './fieldsets/fieldset-readby/fieldset-readby.component';
import { FieldsetFacebookComponent } from './fieldsets/fieldset-facebook/fieldset-facebook.component';
import { FieldsetFileComponent } from './fieldsets/fieldset-file/fieldset-file.component';
import { FieldsetGoogleComponent } from './fieldsets/fieldset-google/fieldset-google.component';
import { FieldsetImageComponent } from './fieldsets/fieldset-image/fieldset-image.component';
import { FieldsetLabelComponent } from './fieldsets/fieldset-label/fieldset-label.component';
import { FieldsetLinkedinComponent } from './fieldsets/fieldset-linkedin/fieldset-linkedin.component';
import { FieldsetMessageComponent } from './fieldsets/fieldset-message/fieldset-message.component';
import { FieldsetNumberComponent } from './fieldsets/fieldset-number/fieldset-number.component';
import { FieldsetCurrencyComponent } from './fieldsets/fieldset-currency/fieldset-currency.component';
import { FieldsetPasswordComponent } from './fieldsets/fieldset-password/fieldset-password.component';
import { FieldsetPasswordlinkComponent } from './fieldsets/fieldset-passwordlink/fieldset-passwordlink.component';
import { FieldsetPhoneComponent } from './fieldsets/fieldset-phone/fieldset-phone.component';
import { FieldsetRadioComponent } from './fieldsets/fieldset-radio/fieldset-radio.component';
import { FieldsetSelectComponent } from './fieldsets/fieldset-select/fieldset-select.component';
import { FieldsetSkypeComponent } from './fieldsets/fieldset-skype/fieldset-skype.component';
import { FieldsetStringComponent } from './fieldsets/fieldset-string/fieldset-string.component';
import { FieldsetTextComponent } from './fieldsets/fieldset-text/fieldset-text.component';
import { FieldsetTimeComponent } from './fieldsets/fieldset-time/fieldset-time.component';
import { FieldsetTwitterComponent } from './fieldsets/fieldset-twitter/fieldset-twitter.component';
import { FieldsetUrlComponent } from './fieldsets/fieldset-url/fieldset-url.component';
import { FieldsetXingComponent } from './fieldsets/fieldset-xing/fieldset-xing.component';
import { FieldsetSignatureComponent } from './fieldsets/fieldset-signature/fieldset-signature.component';
import { FieldsetRegionComponent } from './fieldsets/fieldset-region/fieldset-region.component';
import { FieldsetSecondsComponent } from './fieldsets/fieldset-seconds/fieldset-seconds.component';
import { FieldsetsAllComponent } from './fieldsets/fieldsets-all/fieldsets-all.component';
/** Column components */
import { ColumnBooleanComponent } from './columns/column-boolean/column-boolean.component';
import { ColumnContactComponent } from './columns/column-contact/column-contact.component';
import { ColumnDateComponent } from './columns/column-date/column-date.component';
import { ColumnDateRelativeComponent } from './columns/column-date-relative/column-date-relative.component';
import { ColumnDatetimeComponent } from './columns/column-datetime/column-datetime.component';
import { ColumnDatetimeRelativeComponent } from './columns/column-datetime-relative/column-datetime-relative.component';
import { ColumnDurationComponent } from './columns/column-duration/column-duration.component';
import { ColumnEmailComponent } from './columns/column-email/column-email.component';
import { ColumnEmotionsComponent } from './columns/column-emotions/column-emotions.component';
import { ColumnFacebookComponent } from './columns/column-facebook/column-facebook.component';
import { ColumnGoogleComponent } from './columns/column-google/column-google.component';
import { ColumnImageComponent } from './columns/column-image/column-image.component';
import { ColumnLabelComponent } from './columns/column-label/column-label.component';
import { ColumnLinkedinComponent } from './columns/column-linkedin/column-linkedin.component';
import { ColumnNotesComponent } from './columns/column-notes/column-notes.component';
import { ColumnNumberComponent } from './columns/column-number/column-number.component';
import { ColumnOpenSlotComponent } from './columns/column-open-slot/column-open-slot.component';
import { ColumnPeriodComponent } from './columns/column-period/column-period.component';
import { ColumnPhoneComponent } from './columns/column-phone/column-phone.component';
import { ColumnSelectComponent } from './columns/column-select/column-select.component';
import { ColumnServiceComponent } from './columns/column-service/column-service.component';
import { ColumnSkypeComponent } from './columns/column-skype/column-skype.component';
import { ColumnSpendtimeComponent } from './columns/column-spendtime/column-spendtime.component';
import { ColumnSpendtimeContextComponent } from './columns/column-spendtime-context/column-spendtime-context.component';
import { ColumnStartActiveComponent } from './columns/column-start-active/column-start-active.component';
import { ColumnStringComponent } from './columns/column-string/column-string.component';
import { ColumnTaskComponent } from './columns/column-task/column-task.component';
import { ColumnTextComponent } from './columns/column-text/column-text.component';
import { ColumnTimeComponent } from './columns/column-time/column-time.component';
import { ColumnTimeRelativeComponent } from './columns/column-time-relative/column-time-relative.component';
import { ColumnTwitterComponent } from './columns/column-twitter/column-twitter.component';
import { ColumnUrlComponent } from './columns/column-url/column-url.component';
import { ColumnWeightComponent } from './columns/column-weight/column-weight.component';
import { ColumnXingComponent } from './columns/column-xing/column-xing.component';
import { ColumnEntityComponent } from './columns/column-entity/column-entity.component';
import { ColumnNameComponent } from './columns/column-name/column-name.component';
import { ComponentRegistry } from '../core/component-registry';
/**
 * The supported list columns.
 */
var COLUMN_COMPONENTS = [
    ColumnPhoneComponent,
    ColumnNumberComponent,
    ColumnUrlComponent,
    ColumnDatetimeComponent,
    ColumnContactComponent,
    ColumnSpendtimeComponent,
    ColumnSpendtimeContextComponent,
    ColumnStringComponent,
    ColumnNotesComponent,
    ColumnTimeComponent,
    ColumnDateComponent,
    ColumnStartActiveComponent,
    ColumnDurationComponent,
    ColumnPeriodComponent,
    ColumnOpenSlotComponent,
    ColumnTwitterComponent,
    ColumnSelectComponent,
    ColumnSkypeComponent,
    ColumnGoogleComponent,
    ColumnXingComponent,
    ColumnLinkedinComponent,
    ColumnFacebookComponent,
    ColumnTextComponent,
    ColumnImageComponent,
    ColumnEmailComponent,
    ColumnEmotionsComponent,
    ColumnTaskComponent,
    ColumnServiceComponent,
    ColumnDatetimeRelativeComponent,
    ColumnDateRelativeComponent,
    ColumnTimeRelativeComponent,
    ColumnBooleanComponent,
    ColumnWeightComponent,
    ColumnLabelComponent,
    ColumnEntityComponent,
    ColumnNameComponent
];
/**
 * The supported fieldset types.
 */
var FIELDSET_COMPONENTS = [
    FieldsetMessageComponent,
    FieldsetFileComponent,
    FieldsetImageComponent,
    FieldsetDurationComponent,
    FieldsetBirthdayComponent,
    FieldsetBooleanComponent,
    FieldsetCheckboxesComponent,
    FieldsetDateComponent,
    FieldsetLabelComponent,
    FieldsetDatetimeComponent,
    FieldsetEmailComponent,
    FieldsetNumberComponent,
    FieldsetCurrencyComponent,
    FieldsetSignatureComponent,
    FieldsetPasswordComponent,
    FieldsetPasswordlinkComponent,
    FieldsetPhoneComponent,
    FieldsetRadioComponent,
    FieldsetSelectComponent,
    FieldsetStringComponent,
    FieldsetTextComponent,
    FieldsetTimeComponent,
    FieldsetUrlComponent,
    FieldsetGoogleComponent,
    FieldsetTwitterComponent,
    FieldsetXingComponent,
    FieldsetFacebookComponent,
    FieldsetLinkedinComponent,
    FieldsetSkypeComponent,
    FieldsetEmotionsComponent,
    FieldsetReadByComponent,
    FieldsetRegionComponent,
    FieldsetSecondsComponent,
    FieldsetEntityComponent
];
/**
 * The supported fieldset types.
 */
var INPUTS_COMPONENTS = [
    InputBirthdayComponent,
    InputListComponent,
    InputBooleanComponent,
    InputCheckboxesComponent,
    InputDateComponent,
    InputDateTimeComponent,
    InputDurationComponent,
    InputSecondsComponent,
    InputEmailComponent,
    InputEmotionsComponent,
    InputReadByComponent,
    InputFacebookComponent,
    InputFileComponent,
    InputGoogleComponent,
    InputImageComponent,
    InputLabelComponent,
    InputLinkedinComponent,
    InputNumberComponent,
    InputCurrencyComponent,
    InputSignatureComponent,
    InputPasswordComponent,
    InputPhoneComponent,
    InputRadioComponent,
    InputSelectComponent,
    InputSkypeComponent,
    InputStringComponent,
    InputTextComponent,
    InputTimeComponent,
    InputTwitterComponent,
    InputUrlComponent,
    InputXingComponent,
    InputEntityComponent
];
var BaseModule = /** @class */ (function () {
    /**
     * Creates an instance of the BaseModule.
     */
    function BaseModule() {
        COLUMN_COMPONENTS.forEach(function (columnClass) {
            columnClass.register();
        });
        FIELDSET_COMPONENTS.forEach(function (fieldSetClass) {
            fieldSetClass.register();
        });
        ComponentRegistry.register('route', 'FieldsetsAllComponent', FieldsetsAllComponent);
    }
    return BaseModule;
}());
export { BaseModule };
